import { createSlice } from '@reduxjs/toolkit';
import { type SiteDataType } from './types.ts';
import { fetchSiteData } from '../api/fetchSiteData.ts';

interface SiteDataState {
  data: SiteDataType | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: SiteDataState = {
  data: null,
  isLoading: false,
  error: null,
};

const siteDataSlice = createSlice({
  name: 'siteData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSiteData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSiteData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchSiteData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Неизвестная ошибка';
      });
  },
});

export default siteDataSlice.reducer;
